import _ from "lodash";
import { request } from "ice";
import localStore from 'store';

// 获取员工信息
const getUniversityUserInfo = async () => {
  // return await request.post(`/api-node/university/getUniversityUserInfo`)
  return await request.get(`/api-training-center-system/v1/user/info`)
}
// 查询用户的应用角色
const queryUserToRole = async (params) => {
  // return await request.post(`/api-node/external/role/auth/queryUserToRole`, params)
  return await request.post(`/api-external/sysuser/queryCurrentUserDetails`, params)
}
// 是否需要首次修改密码
const requireResetPassword = async () => {
  return await request.post(`/api-node/sysuser/requireResetPassword`);
};
// 获取鲁工用户角色信息
export const queryLuUserRole = async () => {
  return await request.get(`/api-training-center-system/v1/user/roles`)
}

export const loginFunc = async (callback: any) => {
  // 是否需要重置密码
  // try {
  //   const requireRes = await requireResetPassword()
  //   if (requireRes['resp_code'] == 200) {
  //     localStore.set('requireResetPassword', requireRes.datas)
  //   }
  // } catch (e) {
  //   console.log('requireResetPassword', e.message)
  // }
  // 获取员工信息
  try {
    const UserInfo = await getUniversityUserInfo()
    if (UserInfo['resp_code'] == 200) {
      localStore.set('employeeInfo', UserInfo.datas)
      // 获取角色列表
      try {
        const roleListRes = await queryUserToRole({ userId: UserInfo.datas.userId, appCode: '25f5d7d10e9049328539c3eba91658a8' })
        if (roleListRes['resp_code'] == 200) {
          const roleListStr = _.join(_.map(roleListRes.datas.roleInfo, 'roleName'), ',')
          localStore.set('roleListStr', roleListStr)
        }
      } catch (e) {
        console.log('queryUserToRole', e.message)
      }
      // 获取是否讲师
      try {
        const roleLuList = await queryLuUserRole()
        if (roleLuList['resp_code'] == 200) {
          if (roleLuList['datas'].includes('lecturer')) {
            localStore.set('isLecturer', '1')
          }
          callback()
        }
      } catch (e) {
        console.log('queryLuUserRole', e.message)
      }
    }
  } catch (e) {
    console.log('getUniversityUserInfo', e.message)
  }
}
